import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../../core/services/user.service';
import * as _ from 'lodash';


@Component({
  templateUrl: './permissions-page.html',
  styleUrls: ['./permissions-page.scss'],
})

export class PermissionsPageComponent {

  letters = [
    'א',
    'ב',
    'ג',
    'ד',
    'ה',
    'ו',
    'ז',
    'ח',
    'ט',
    'י',
    'כ',
    'ל',
    'מ',
    'נ',
    'ס',
    'ע',
    'פ',
    'צ',
    'ק',
    'ר',
    'ש',
    'ת',
  ];
  allUsers = [];
  users = {};

  constructor(
    private router:Router,
    private userService:UserService,
  ) {
  }


  async ngOnInit() {

    const result = await this.userService.find({});
    this.allUsers = result.data;

    // store users, indexed by email
    this.users = {};
    this.allUsers.forEach(user => {
      this.users[user.email] = user;
    });


  }


  navTo(dest) {
    this.router.navigate([dest]);
  }


  userHasPermission(userEmail, letter) {

    const user = this.users[userEmail];

    return (user) ? user.lettersEnabled.includes(letter) : false;
  }


  toggleSection(userEmail, letter) {

    const newUserPermissions = _.clone(this.users[userEmail].lettersEnabled);

    if (this.userHasPermission(userEmail, letter)) {
      _.remove(newUserPermissions, n => n == letter);
    } else {
      newUserPermissions.push(letter);
    }

    Promise.resolve()
      .then(() => this.userService.patch(this.users[userEmail]._id, {
        lettersEnabled: newUserPermissions
      }))
      .then(newUser => {
        this.users[userEmail] = newUser;
      });

  }


}



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/permissions-page/permissions-page.ts